import { render, staticRenderFns } from "./AddressEditForm.vue?vue&type=template&id=794da792&"
import script from "./AddressEditForm.vue?vue&type=script&lang=ts&"
export * from "./AddressEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddressEditForm.vue?vue&type=style&index=0&id=794da792&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports